import api from '../../utils/api';
import {
    GET_LIST_PRESCRIPTION_TEMPLATE,
    GET_SPECIFIC_PRESCRIPTION_TEMPLATE,
    UPDATE_SPECIFIC_PRESCRIPTION_TEMPLATE,
    CREATE_NEW_PRESCRIPTION_TEMPLATE,
    REMOVE_PRESCRIPTION_TEMPLATE,
    GET_PRESCRIPTION_TEMPLATE_ACTIVE
} from './types';
import { NotificationManager } from 'react-notifications';

/**
 * Lấy danh sách Prescription Template theo bộ lọc
 */
export const getListPrescriptionTemplate = (filter) => (dispatch) => {
    return new Promise((resolve, reject) => {
        api
            .get('/prescription-templates', { params: filter })
            .then((res) => {
                dispatch({ type: GET_LIST_PRESCRIPTION_TEMPLATE, payload: res.data.data });
                resolve(res.data);
            })
            .catch((err) => {
                console.error(err);
                NotificationManager.error(
                    err.response?.data?.msg || 'Không thể tải danh sách Prescription Template'
                );
                reject(err);
            });
    });
};

/**
 * Lấy Prescription Template cụ thể theo ID
 */
export const getSpecificPrescriptionTemplate = (id) => (dispatch) => {
    return new Promise((resolve, reject) => {
        api
            .get(`/prescription-templates/${id}`)
            .then((res) => {
                dispatch({ type: GET_SPECIFIC_PRESCRIPTION_TEMPLATE, payload: res.data.data });
                resolve(res.data.data);
            })
            .catch((err) => {
                NotificationManager.error(
                    err.response?.data?.msg || 'Không thể lấy chi tiết Prescription Template'
                );
                reject(err);
            });
    });
};

/**
 * Lấy danh sách Prescription Template đang hoạt động
 */
export const getPrescriptionTemplateActive = (filter) => (dispatch) => {
    return new Promise((resolve, reject) => {
        api
            .get('/prescription-templates/active', { params: filter })
            .then((res) => {
                dispatch({ type: GET_PRESCRIPTION_TEMPLATE_ACTIVE, payload: res.data });
                resolve(res.data);
            })
            .catch((err) => {
                console.error(err);
                NotificationManager.error(
                    err.response?.data?.msg || 'Không thể tải danh sách đang hoạt động'
                );
                reject(err);
            });
    });
};

/**
 * Tạo mới Prescription Template
 */
export const createPrescriptionTemplate = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        api
            .post('/prescription-templates', data)
            .then((res) => {
                dispatch({ type: CREATE_NEW_PRESCRIPTION_TEMPLATE, payload: res.data.data });
                NotificationManager.success('Thêm mới Prescription Template thành công!');
                resolve(res.data.data);
            })
            .catch((err) => {
                NotificationManager.error(
                    err.response?.data?.msg || 'Thêm mới Prescription Template thất bại'
                );
                reject(err);
            });
    });
};

/**
 * Cập nhật Prescription Template
 */
export const updatePrescriptionTemplate = (id, data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        api
            .put(`/prescription-templates/${id}`, data)
            .then((res) => {
                dispatch({ type: UPDATE_SPECIFIC_PRESCRIPTION_TEMPLATE, payload: res.data.data });
                NotificationManager.success('Cập nhật Prescription Template thành công!');
                resolve(res.data);
            })
            .catch((err) => {
                NotificationManager.error(
                    err.response?.data?.msg || 'Cập nhật Prescription Template thất bại'
                );
                reject(err);
            });
    });
};

/**
 * Xoá một hoặc nhiều Prescription Template
 */
export const removePrescriptionTemplate = (ids) => (dispatch) => {
    return new Promise((resolve, reject) => {
        api
            .delete('/prescription-templates', { data: { ids } })
            .then((res) => {
                dispatch({ type: REMOVE_PRESCRIPTION_TEMPLATE, payload: ids });
                NotificationManager.success('Xoá Prescription Template thành công!');
                resolve(res.data);
            })
            .catch((err) => {
                console.error(err);
                NotificationManager.error(
                    err.response?.data?.msg || 'Xoá Prescription Template thất bại'
                );
                reject(err);
            });
    });
};
